import React from 'react';
import { G, Line, Path, Polygon, Rect, Text as SvgText } from 'react-native-svg';
import { DiagramCanvas } from '../DiagramCanvas';
import { FormulaTag } from '../FormulaTag';
import { LeaderLine } from '../LeaderLine';
import { DT } from '../tokens';

/** Fitting loss → equivalent length of straight duct. */
export function DiagramFittingLossEquivalentLength() {
  const dy = 75, dh = 50;
  const cy = dy + dh / 2;

  return (
    <DiagramCanvas>
      {/* Real-world: straight + 90° elbow */}
      <SvgText x={175} y={28} fill={DT.desc} fontSize="9" fontFamily={DT.mono} textAnchor="middle">Actual fitting (90° elbow)</SvgText>

      {/* Straight upstream */}
      <Rect x={20} y={dy} width={90} height={dh} fill={DT.fill} stroke={DT.stroke} strokeWidth="1.5" />
      {/* Elbow body — turn down */}
      <Path d={`M110,${dy} L165,${dy} A20,20 0 0 1 185,${dy + 20} L185,${dy + 80} L135,${dy + 80} L135,${dy + 30} A5,5 0 0 0 130,${dy + 25} L110,${dy + 25} Z`}
        fill={DT.fill} stroke={DT.stroke} strokeWidth="1.5" />

      {/* Flow arrow through elbow (curved) */}
      <Path d={`M30,${cy} L155,${cy} A15,15 0 0 1 170,${cy + 15} L170,${dy + 70}`}
        fill="none" stroke={DT.arrow} strokeWidth="1.5" />
      <Polygon points={`170,${dy + 72} 166,${dy + 66} 174,${dy + 66}`} fill={DT.arrow} />

      {/* Pressure-loss "swirl" indicator inside elbow */}
      <Path d={`M150,${dy + 18} a6,6 0 1 1 0.1,0`} fill="none" stroke={DT.varColor} strokeWidth="1" opacity={0.7} />
      <Polygon points={`156,${dy + 18} 152,${dy + 14} 152,${dy + 22}`} fill={DT.varColor} opacity={0.7} />

      {/* Equivalent: long straight duct of length Le */}
      <SvgText x={175} y={170} fill={DT.desc} fontSize="9" fontFamily={DT.mono} textAnchor="middle">Equivalent: Le of straight duct</SvgText>
      <Rect x={20} y={180} width={300} height={26} fill={DT.fill} stroke={DT.varColor} strokeWidth="1.2" strokeDasharray="4,3" />
      {/* Flow arrow */}
      <Line x1={30} y1={193} x2={300} y2={193} stroke={DT.arrow} strokeWidth="1.5" />
      <Polygon points="302,193 296,189 296,197" fill={DT.arrow} />

      {/* Le dimension */}
      <Line x1={20} y1={172} x2={320} y2={172} stroke={DT.varColor} strokeWidth="1" />
      <Line x1={20} y1={168} x2={20} y2={176} stroke={DT.varColor} strokeWidth="1" />
      <Line x1={320} y1={168} x2={320} y2={176} stroke={DT.varColor} strokeWidth="1" />
      <SvgText x={170} y={166} fill={DT.varColor} fontSize="10" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">Le</SvgText>

      {/* Equivalence symbol */}
      <SvgText x={250} y={130} fill={DT.varColor} fontSize="14" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">≡</SvgText>
      <SvgText x={250} y={146} fill={DT.desc} fontSize="8" fontFamily={DT.mono} textAnchor="middle">same ΔP</SvgText>

      {/* Labels */}
      <LeaderLine x1={150} y1={dy + 12} x2={290} y2={60} varName="Fitting" desc="elbow / tee" anchor="end" />
      <LeaderLine x1={170} y1={dy + 70} x2={310} y2={130} varName="ΔP" desc="dynamic loss" anchor="end" />

      <FormulaTag formula="ΔP_fitting = (ΔP/100 ft) · Le" />
    </DiagramCanvas>
  );
}
